/*
Use on a page:
	<span id="..." data-bind="triStateCheckbox: areAllLessonsVisible, triStateDisabled: isLoading"></span>
Use in a model:
	define(['BindingHandler/triStateCheckbox']...
You should define observable property with NULL:
	self.areAllLessonsVisible = ko.observable(null);
*/
define('v3/Common/Bindings/TriStateCheckbox.Bindings',[
	'knockout',
	'jquery',
	'triStateCheckbox'
], function (ko, $) {
	ko.bindingHandlers['triStateCheckbox'] = {
		init: function (element, valueAccessor, allBindingsAccessor) {
			var bindingChecked = valueAccessor();
			var checked = ko.unwrap(bindingChecked);
			if (checked === null) { checked = 'mixed'; }
			var bindingDisabled = allBindingsAccessor.get('triStateDisabled');
			var enable = !ko.unwrap(bindingDisabled);
			//
			var el = $.fn.TriStateCheckbox({ checked: checked, enabled: enable });
			var checkedChanging = false;
			//
			if (ko.isObservable(bindingChecked)) {
				$(el).on('checked', function () {
					if (checkedChanging) {
						return;
					}
					var newValue = this.checked();
					if (newValue === 'mixed') { newValue = null; }
					// console.debug("triStateBinding Set Model = ", newValue, el.parentElement.id);
					bindingChecked(newValue);
				});
				bindingChecked.subscribe(function (newValue) {
					if (newValue === null) { newValue = 'mixed'; }
					var oldValue = el.checked();
					if (newValue !== oldValue) {
						// console.debug("triStateBinding Set UI    = ", newValue, el.parentElement.id);
						checkedChanging = true;
						el.checked(newValue);
						checkedChanging = false;
					}
				});
			}
			if (ko.isObservable(bindingDisabled)) {
				bindingDisabled.subscribe(function (newValue) {
					// console.debug("Event: bindingDisabled changed: new value = ", newValue);
					newValue = !newValue;
					var oldValue = el.enabled();
					if (newValue !== oldValue) {
						el.enabled(newValue);
					}
				});
			}
			//
			$(element).click(function (e) {
				if (!$(e.target).hasClass('TriStateCheckbox')) { $(el).triggerHandler('click'); }
			});
			$(element).prepend(el);
		}
	};
});
